// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getRolesIndex: ({commit, state}, params) => request.alert('getRolesIndex', params),
  getRoleDetail: ({commit, state}, params) => request.alert('getRoleDetail', params),
  addRole: ({commit, state}, params) => request.alert('addRole', params),
  editRole: ({commit, state}, params) => request.alert('editRole', params),
  copyRole: ({commit, state}, params) => request.alert('copyRole', params),
  deleteRole: ({commit, state}, params) => request.alert('deleteRole', params),
}

// mutations
const mutations = {}

export const platformRole = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform-role/platform-role.store.js